import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitEvaluation = (payload) => api.post("/leads/evaluation", payload).then(r => r.data);
export const submitInspection = (payload) => api.post("/leads/inspection", payload).then(r => r.data);
export const submitContact = (payload) => api.post("/leads/contact", payload).then(r => r.data);

export const submitUpload = (payload, files) => {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => v != null && fd.append(k, v));
  (files || []).forEach((f) => fd.append("files", f));
  return axios.post(`${API}/leads/upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);
};
